module.exports = __webpack_public_path__ + "img/global-map.cb0b01e9.png";